module.exports = __webpack_public_path__ + "img/p2-85.cc226e0c.png";